import { AppState } from 'Store'

const getEntries = (state: AppState) => state.adminSlice.tag.tag.entries

const getTotal = (state: AppState) => state.adminSlice.tag.tag.total_entries

const getRandomTags = (state) => state.adminSlice.tag.random_tag
const getRequestParams = (state: AppState) => state.adminSlice.tag.requestParams

const getEditId = (state) => state.adminSlice.tag.editId
const getDataItem = (state) => state.adminSlice.tag.dataItem

export const tagSelector = {
	getEntries,
	getRandomTags,
	getRequestParams,
	getTotal,
	getEditId,
	getDataItem,
}
